import { cn } from "@shared/lib/utils";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

interface ExpandablePanelProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
  headerClassName?: string;
  titleClassName?: string;
  statusBadge?: React.ReactNode;
}

const ExpandablePanel: React.FC<ExpandablePanelProps> = ({
  title,
  children,
  defaultExpanded = true,
  className,
  headerClassName,
  titleClassName,
  statusBadge,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <Card className={cn("mb-4 overflow-hidden shadow-sm border", className)}>
      <CardHeader
        className={cn(
          "px-4 py-3 flex flex-row items-center justify-between bg-secondary/50 cursor-pointer",
          headerClassName
        )}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <CardTitle className={cn("text-base font-medium", titleClassName)}>
            {title}
          </CardTitle>
          {statusBadge}
        </div>
        <Button variant="ghost" size="sm" className="p-0 h-8 w-8 rounded-full">
          {isExpanded ? (
            <ChevronUp className="h-5 w-5" />
          ) : (
            <ChevronDown className="h-5 w-5" />
          )}
        </Button>
      </CardHeader>

      <div
        className={cn(
          "transition-all duration-300 ease-in-out",
          isExpanded ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"
        )}
      >
        <CardContent className="p-4">{children}</CardContent>
      </div>
    </Card>
  );
};

export default ExpandablePanel;
